<script>
  import pessoaServico from '~modulos/pessoa/servico';
  import solicitacaoAdiantamentoServico from '../servico';
  import AdicionarArquivos from '~componentes/FormAdicionarArquivos.vue';
  import ListaDeArquivos from '~componentes/ListaDeArquivos.vue';
  import DadosCadastrais from './compartilhado/FormDadosCadastrais.vue';
  import DadosPagamento from './compartilhado/FormDadosPagamento.vue';
  import DadosBancarios from './compartilhado/FormDadosBancarios.vue';
  import DadosViagem from './compartilhado/FormDadosViagem.vue';
  import DespesasRubricas from './compartilhado/FormDespesasRubricas.vue';
  import { alert } from 'vue-strap';
  import radio from '~componentes/Radio.vue';
  
  export default {
    components: { DadosCadastrais, DadosPagamento, DadosBancarios, radio, DadosViagem, DespesasRubricas, AdicionarArquivos, ListaDeArquivos, alert },
    data() {
      return {
        documento: '',
        tipoDocumento: 'CPF',
        mostrarFormulario: false,
        solicitacao: this.camposSolicitacao(),
        carregando: false,
        dadosBancarios: [],
        dadosBancariosPIX: [],
        configuracao: this.$storage.configuracao(),
        arquivos: [],
        solicitacoesEmAberto: [],
        desabilitarSalvar: false,
        desabilitarBeneficiario: false,
      }
    },
    mounted() {
      this.$root.tituloDaPagina = `Solicitação de Adiantamento - ${this.$route.params.id ? 'Editar #' + this.$route.params.id : 'Nova'}`;
      this.$root.botaoAcaoTexto = 'Nova';
      this.$root.botaoAcaoIcon = 'fa-plus';
      this.$root.botaoAcaoLink = 'solicitacao-adiantamento.nova';
    },
    methods: {
      buscaDesabilitarBeneficiario() {
        if (this.configuracao.permissaoAlteracaoNomeBeneficiario != 0)
          return false;

        if (!this.solicitacao.cpf)
          return false;

        return pessoaServico
          .busca(this.solicitacao.cpf)
          .then(pessoa => {
            if (pessoa.nomePessoaFisicaJuridica)
              this.desabilitarBeneficiario = true;
          })
          .catch(error => {
            });
      },
      buscarBeneficiario() {
        $('#avancar').button('loading');

        return pessoaServico
          .busca(this.documento)
          .then(pessoa => {
            $('#avancar').button('reset');

            this.solicitacao.cpf = pessoa.cpfCnpj;
            this.solicitacao.nomeRequerinte = pessoa.nomePessoaFisicaJuridica;
            this.solicitacao.telefone = pessoa.telefone1;
            this.solicitacao.celular = pessoa.telefone2;
            this.solicitacao.email = pessoa.email;
            this.dadosBancarios = pessoa.dadosBancarios;
            this.dadosBancariosPIX = pessoa.dadosBancariosPIX;
            this.solicitacao.endereco = pessoa.endereco ? pessoa.endereco.substring(0, 100) : pessoa.endereco;
            this.solicitacao.numero = pessoa.numero ? pessoa.numero.substring(0, 10) : pessoa.numero;
            this.solicitacao.complemento = pessoa.complemento ? pessoa.complemento.substring(0, 80) : pessoa.complemento;
            this.solicitacao.bairro = pessoa.bairro ? pessoa.bairro.substring(0, 80) : pessoa.bairro;
            this.solicitacao.cidade = pessoa.cidade ? pessoa.cidade.substring(0, 60) : pessoa.cidade;
            this.solicitacao.uf = pessoa.estado;
            this.solicitacao.cep = pessoa.cep;
            this.solicitacao.dataNascimento = this.$options.filters.formatarNumeroEmData(pessoa.dataNascimento);

          })
          .then(() => {
            if (this.configuracao.utilizarPrestacaoContasAdiantamento) {
              return solicitacaoAdiantamentoServico.pendenciaPorCpf(this.documento);
            }
          })
          .then(resultado => {
            if (resultado) {
              toastr.warning(`Não é possível fazer solicitações de adiantamento para o ${this.tipoDocumento} ${this.documento} por 
                haver declaração(ões) de despesa em aberto, seja nesse projeto ou em outros.`, '', {timeOut: 10000});
              
              return true;
            }
          })
          .then(pendenciaCpf => {
            if (pendenciaCpf) return;
            
            this.$set(this, 'mostrarFormulario', true);

            this.$events.emit('carregarProjetos');

            this.mostrarInstrucoes();

            this.buscaDesabilitarBeneficiario();
          })
          .catch(error => {
            $('#avancar').button('reset');

            this.solicitacao.cpf = this.documento;

            this.$set(this, 'mostrarFormulario', true);

            this.$events.emit('carregarProjetos');
            this.mostrarInstrucoes();
          });
      },
      validarBeneficiario() {
        this.$validator
          .validate('documento', this.documento)
          .then(valido => {
            if (!valido) throw new Error("validacao");
          })
          .then(this.buscarBeneficiario)
          .then(this.buscarEmAberto)
          .catch(erro => {
            this.$mensagemErro(erro);
          });
      },
      buscarEmAberto() {
        return solicitacaoAdiantamentoServico
          .emAberto(this.documento)
          .then(lista => {
            this.solicitacoesEmAberto = lista;
          });
      },
      camposSolicitacao() {
        return {
          idProjeto: null,
          nomeRequerinte: '',
          cpf: '',
          email: null,
          telefone: '',
          celular: '',
          agencia: '',
          banco: '',
          conta: '',
          tipoConta: '',
          tipoPessoa: '',
          tipoPix: '',
          chavePix: '',
          despesasViajem: [],
          prestacaoRealizada: null,
          adiantamentoViagem: 1,
          formaPagamento: '',
          dataPagamento: '',
          localidade: '',
          dataPartida: '',
          dataRetorno: '',
          finalidadeViagem: '',
          dataNascimento: '',
          endereco: null,
          numero: null,
          complemento: null,
          bairro: null,
          cidade: null,
          cep: null,
          uf: '', 
          projeto: {
            nomeProjeto: ''
          }
        }
      },
      salvar() {
        $('#salvar').button('loading');

        this.$refs.dadosCadastrais
          .validar()
          .then(valido => {
            if (!valido) {
              $('#tabs a[href="#tab-dados-cadastrais"]').tab('show');
            }

            return valido;
          })
          .then(this.$refs.dadosPagamento.validar)
          .then(valido => {
            if (!valido) {
              $('#tabs a[href="#tab-dados-pagamento"]').tab('show');
            }

            return valido;
          })
          .then(this.$refs.dadosBancarios.validar)
          .then(valido => {
            if (!valido) {
              $('#tabs a[href="#tab-dados-bancarios"]').tab('show');
            }

            return valido;
          })
          .then(this.$refs.dadosViagem.validar)
          .then(valido => {
            if (!valido) {
              $('#tabs a[href="#tab-dados-viagem"]').tab('show');
            }

            return valido;
          })
          .then(this.validarDataDadosViagem)
          .then(this.validarSePossuiDespesa)
          .then(this.enviar)
          .then(id => {
            this.$imprimirRelatorio('solicitacao-adiantamento.relatorio', id, 'solicitacao-adiantamento');
          })
          .catch(erro => {
            $('#salvar').button('reset');
            this.$mensagemErro(erro, 'Erro ao salvar a solicitação.');
          });
      },
      enviar(valido) {
        if (!valido) throw new Error("validacao com erro");

        const copiaSolicitacao = JSON.parse(JSON.stringify(this.solicitacao));

        copiaSolicitacao.arquivosDeletados = this.$refs.listaArquivos.deletados;
        const arquivos = this.$refs.adicionarArquivos.arquivos;

        if (this.$route.params.id) {
          return solicitacaoAdiantamentoServico.alterar(copiaSolicitacao, arquivos, this.$route.params.idCript);
        } else {
          return solicitacaoAdiantamentoServico.adicionar(copiaSolicitacao, arquivos);
        }
      },
      mostrarInstrucoes() {
        if (!this.configuracao.instrucoesSolAdiantamento || this.$route.params.id) return;

        this.$swal({
          title: 'Instruções da solicitação',
          html: this.configuracao.instrucoesSolAdiantamento.replace(/\r\n/g, '<br>'),
          type: 'info',
          confirmButtonText: 'Ok, entendi!',
          allowOutsideClick: false,
          allowEscapeKey: false,
        });
      },
      validarSePossuiDespesa(valido) {
        if (!valido) throw new Error("validacao com erro");

        if (this.solicitacao.despesasViajem.length > 0) return true;

        $('#tabs a[href="#tab-despesas-rubricas"]').tab('show');
        
        this.$swal(
          '',
          'A solicitação deve possuir ao menos uma despesa.',
          'info'
        );

        throw new Error("validacao");
      },
      validarDataDadosViagem(valido) {
        if (this.solicitacao.adiantamentoViagem == 0)
          return true;

        if (!valido) throw new Error("validacao com erro");

        let dataPartida = moment(this.solicitacao.dataPartida, 'DD/MM/YYYY');
        let dataRetorno = moment(this.solicitacao.dataRetorno, 'DD/MM/YYYY');

        if (!dataPartida.isSameOrBefore(dataRetorno)) {
          $('#tabs a[href="#tab-dados-viagem"]').tab('show');
          
          this.$swal(
            '',
            'A data de partida deve ser anterior ou igual a data de retorno.',
            'info'
          );

          throw new Error("validacao");
        }

        return valido;
      },
      limparDadoBancario() {
        if (this.solicitacao.formaPagamento !== 0) {
          this.solicitacao.banco = '';
          this.solicitacao.agencia = '';
          this.solicitacao.conta = '';
          this.solicitacao.tipoPix = '';
          this.solicitacao.chavePix = '';
          this.solicitacao.tipoConta = this.tipoContaPix === 2 ? 4 : '';
          this.solicitacao.tipoPessoa = '';

          this.$validator.reset();
        }
      },
      setarAdiantamentoPessoa() {
        this.documento = '';

        if (this.tipoDocumento == 'CNPJ')
          this.solicitacao.adiantamentoViagem = 0
        else 
          this.solicitacao.adiantamentoViagem = 1;
      },
      habilitarDesabilitarProjeto() {
        $('#projeto').prop('disabled', this.solicitacao.despesasViajem.length > 0);
      },
      download(arquivo) {
        solicitacaoAdiantamentoServico
          .download(this.$route.params.id, arquivo)
          .then(arquivo => {
            arquivo.download();
          });
      },
      carregar(id) {
        this.carregando = true;

        let solicitacao = null;

        solicitacaoAdiantamentoServico
          .obterPorId(id)
          .then(dados => {
            solicitacao = dados;
          })
          .then(() => {
            return this.carregarDadosBancarios(solicitacao.cpf);
          })
          .then(() => {
            return this.carregarDadosBancariosPIX(solicitacao.cpf);
          })
          .then(() => solicitacaoAdiantamentoServico.arquivos(id))
          .then(arquivos => {
            this.arquivos = arquivos;
          })
          .then(() => {
            solicitacao.dataNascimento = this.$options.filters.formatarNumeroEmData(solicitacao.dataNascimento);
            this.$set(this, 'solicitacao', solicitacao);
            this.carregando = false;
            solicitacao.cpf.length === 14 ? this.$set(this, 'tipoDocumento', 'CPF') : this.$set(this, 'tipoDocumento', 'CNPJ');

            if (solicitacao.tipoConta != null)
              this.$refs.dadosBancarios.setarTipoBancario(parseInt(solicitacao.tipoConta));

            this.buscaDesabilitarBeneficiario();
          });
      },
      carregarDadosBancarios(cpf) {
        return pessoaServico
          .dadosBancarios(cpf)
          .then(dadosBancarios => {
            this.dadosBancarios = dadosBancarios;
          })
      },
      carregarDadosBancariosPIX(cpf) {
        return pessoaServico
          .dadosBancariosPIX(cpf)
          .then(dadosBancarios => {
            this.dadosBancariosPIX = dadosBancarios;
          })
      },
      habilitarOuDesabilitarSalvar(valor) {
        this.desabilitarSalvar = valor;
      },
      resetarComponente() {
        Object.assign(this.$data, this.$options.data.apply(this));
      },
    },
    created() {
      if (this.$route.params.id) {
        this.$set(this, 'mostrarFormulario', true);
        this.carregar(this.$route.params.id);
      }
    },
    watch: {
      'solicitacao.formaPagamento': 'limparDadoBancario',
      'solicitacao.despesasViajem.length': 'habilitarDesabilitarProjeto',
      'tipoDocumento': 'setarAdiantamentoPessoa'
    }
  }
</script>

<template>
  <div :class="'wrapper wrapper-content animated ' + $root.animacaoPadrao">
    <alert type="warning" v-if="solicitacoesEmAberto.length > 0 && mostrarFormulario">
      <p>
        A liberação do adiantamento solicitado está condicionado a prestação de
        contas dos adiantamentos em aberto.<br>Caso queira prosseguir com a
        solicitação a mesma será analisada pela equipe financeira.
      </p>
      
      <table class="table table-bordered margin-top-10">
        <thead>
          <tr>
            <th class="transparent">Código</th>
            <th class="transparent">Data de pagamento</th>
            <th class="transparent">Valor</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="s in solicitacoesEmAberto">
            <td class="text-center">{{ s.id }}</td>
            <td>{{ s.data | formatarData }}</td>
            <td class="text-right">{{ s.valor | formatarNumero }}</td>
          </tr>
        </tbody>
      </table>
    </alert>
    
    <form @submit.prevent="validarBeneficiario">

      <div class="row" v-if="mostrarFormulario">
        
        <div class="col-xs-12">
          <div class="ibox float-e-margins" v-if="carregando">
            <div class="ibox-content">
              <p class="text-center">
                <i class='fa fa-spinner fa-pulse'></i> Carregando...
              </p>
            </div>
          </div>
        </div>

        <div class="tabs-container" v-show="!carregando" id="tabs">
          <ul class="nav nav-tabs">
            <li class="active">
              <a
                data-toggle="tab"
                href="#tab-dados-cadastrais">
                Dados cadastrais
              </a>
            </li>
            <li>
              <a
                data-toggle="tab"
                href="#tab-dados-pagamento">
                Dados para pagamento
              </a>
            </li>
            <li :class="{'disabled': solicitacao.formaPagamento !== 0}">
              <a
                @click.prevent=""
                :data-toggle="solicitacao.formaPagamento === 0 ? 'tab' : ''"
                href="#tab-dados-bancarios">
                Dados bancários
              </a>
            </li>
            <li :class="{'disabled': solicitacao.adiantamentoViagem !== 1}">
              <a
                @click.prevent=""
                :data-toggle="solicitacao.adiantamentoViagem === 1 ? 'tab' : ''"
                href="#tab-dados-viagem">
                Dados da viagem
              </a>
            </li>
            <li :class="{'disabled': solicitacao.idProjeto === null}">
              <a
                @click.prevent=""
                :data-toggle="solicitacao.idProjeto !== null ? 'tab' : ''"
                href="#tab-despesas-rubricas">
                Despesas com rubricas
              </a>
            </li>
            <li v-if="configuracao.usarArquivosSolicitacaoAdiantamento">
              <a
                data-toggle="tab"
                href="#tab-adicionar-arquivos">
                Adicionar arquivos
              </a>
            </li>
            <li v-if="$route.params.id && configuracao.usarArquivosSolicitacaoAdiantamento">
              <a
                data-toggle="tab"
                href="#tab-lista-arquivos">
                Arquivos
              </a>
            </li>
          </ul>
          <div class="tab-content">

            <div id="tab-dados-cadastrais" class="tab-pane active">
              <div class="panel-body">
                <dados-cadastrais
                  ref="dadosCadastrais"
                  :solicitacao="solicitacao"
                  :edicao="!!$route.params.id"
                  :tipoDocumento="this.tipoDocumento"
                  :desabilitarBeneficiario="this.desabilitarBeneficiario"
                  @habilitarOuDesabilitarSalvar="habilitarOuDesabilitarSalvar">
                </dados-cadastrais>
              </div>
            </div>

            <div id="tab-dados-pagamento" class="tab-pane">
              <div class="panel-body">
                <dados-pagamento
                  ref="dadosPagamento"
                  :solicitacao="solicitacao"
                  :edicao="!!$route.params.id">
                </dados-pagamento>
              </div>
            </div>

            <div id="tab-dados-bancarios" class="tab-pane">
              <div class="panel-body">
                <dados-bancarios
                  ref="dadosBancarios"
                  :solicitacao="solicitacao"
                  :edicao="!!$route.params.id"
                  :dadosBancarios="dadosBancarios"
                  :dadosBancariosPIX="dadosBancariosPIX">
                </dados-bancarios>
              </div>
            </div>

            <div id="tab-dados-viagem" class="tab-pane">
              <div class="panel-body">
                <dados-viagem
                  ref="dadosViagem"
                  :solicitacao="solicitacao"
                  :edicao="!!$route.params.id">
                </dados-viagem>
              </div>
            </div>

            <div id="tab-despesas-rubricas" class="tab-pane">
              <div class="panel-body">
                <despesas-rubricas
                  ref="despesasRubricas"
                  :solicitacao="solicitacao"
                  :edicao="!!$route.params.id">
                </despesas-rubricas>
              </div>
            </div>

            <div id="tab-adicionar-arquivos" class="tab-pane">
              <div class="panel-body">
                <adicionar-arquivos
                  ref="adicionarArquivos">
                </adicionar-arquivos>
              </div>
            </div>

            <div id="tab-lista-arquivos" class="tab-pane">
              <div class="panel-body">
                <lista-de-arquivos
                  :arquivos="arquivos"
                  @download="download"
                  ref="listaArquivos">
                </lista-de-arquivos>
              </div>
            </div>
            
          </div>
        </div>
        
      </div>

      <div class="row" v-if="!mostrarFormulario">
        <div class="col-sm-12">
            <div class="form-group radios">
              <radio
                  v-model="tipoDocumento"
                  selected-value="CPF"
                  type="success"
                  :inline="true"
                  class="no-margin-top no-margin-bottom margin-right-10">
                Pessoa Física
              </radio>
              <radio
                  v-model="tipoDocumento"
                  selected-value="CNPJ"
                  type="success"
                  :inline="true"
                  class="no-margin-top no-margin-bottom">
                Pessoa Jurídica
              </radio>
            </div>

          <div class="form-group required" :class="{'has-error': errors.has('documento')}">
            <label class="control-label" for="documento">{{ tipoDocumento }} do Beneficiário</label>

            <input type="text"
                   class="form-control"
                   id="documento"
                   v-model="documento"
                   data-vv-as="documento"
                   data-vv-name="documento"
                   v-mascara="tipoDocumento.toLocaleLowerCase()"
                   v-validate="`required|${tipoDocumento.toLocaleLowerCase()}`">

            <p class="text-danger" v-show="errors.has('documento')">{{ errors.first('documento') }}</p>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-xs-12">
          <div class="form-group">
            <router-link
              class="btn btn-default"
              :to="{ name: 'solicitacao-adiantamento' }"
              v-show="!mostrarFormulario || !!$route.params.id"
              active-class="">
              <i class="fa fa-arrow-left"></i>
              Voltar
            </router-link>

            <button
              id="avancar"
              type="button"
              class="btn btn-primary"
              @click="validarBeneficiario"
              v-show="!mostrarFormulario"
              data-loading-text="<i class='fa fa-spinner fa-pulse'></i> Carregando...">
              Avançar
              <i class="fa fa-arrow-right"></i>
            </button>

            <button
              type="button"
              class="btn btn-default"
              @click="mostrarFormulario = false, resetarComponente()"
              v-show="mostrarFormulario && !(!!$route.params.id)">
              <i class="fa fa-arrow-left"></i>
              Volta
            </button>

            <button
              id="salvar"
              type="button"
              class="btn btn-primary"
              @click="salvar"
              v-show="mostrarFormulario"
              :disabled="desabilitarSalvar"
              data-loading-text="<i class='fa fa-spinner fa-pulse'></i> Salvando...">
              <i class="fa fa-save"></i>
              Salvar
            </button>
          </div>
        </div>
      </div>
      
    </form>
  </div>
</template>



// WEBPACK FOOTER //
// FrontEnd/modulos/solicitacao-adiantamento/componentes/SolicitacaoAdiantamentoForm.vue